import { render } from "./WarningsStatistics.vue?vue&type=template&id=5a11963c&scoped=true"
import script from "./WarningsStatistics.vue?vue&type=script&lang=js"
export * from "./WarningsStatistics.vue?vue&type=script&lang=js"

import "./WarningsStatistics.vue?vue&type=style&index=0&id=5a11963c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a11963c"]])

export default __exports__